import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_URL } from '../../common/variables';

const requestOrderStats = createAsyncThunk(
  'REQUEST_ORDERS_STATS',
  async (merchantId, { getState, rejectWithValue }) => {
    try {
      const { token } = getState().app;
      let res = await fetch(
        API_URL + '/subscriptions/get-merchant-orders-stats',
        {
          body: JSON.stringify({ live: true, merchantId: merchantId }),
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (res.status === 200) {
        let result = await res.json();
        return result;
      } else return rejectWithValue(res.status);
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
const requestOrdersPagin = createAsyncThunk(
  'REQUEST_ORDERS_PAGIN',
  async (arg, { getState, rejectWithValue }) => {
    try {
      const { token } = getState().app;
      const { filter } = arg;
      let res = await fetch(
        API_URL +
          '/subscriptions/search-merchant-orders-auth-pagination-params',
        {
          body: JSON.stringify({ ...filter, live: true }),
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (res.status === 200) {
        return await res.json();
      }
      return rejectWithValue({ error: true, errorCode: res.status });
    } catch (e) {
      return rejectWithValue({ error: true, errorCode: 900 });
    }
  },
);
const requestOrders = createAsyncThunk(
  'REQUEST_ORDERS',
  async (arg, { getState, rejectWithValue }) => {
    try {
      const { token } = getState().app;
      const { filter } = arg;
      let res = await fetch(
        API_URL + '/subscriptions/search-merchant-orders-auth',
        {
          body: JSON.stringify({ ...filter, live: true }),
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (res.status === 200) {
        return await res.json();
      }
      return rejectWithValue({ error: true, errorCode: res.status });
    } catch (e) {
      return rejectWithValue({ error: true, errorCode: 900 });
    }
  },
);
const changeOrderNewToShipping = createAsyncThunk(
  'CHANGE_NEW_SHIPPING',
  async (arg, { getState, rejectWithValue }) => {
    try {
      const { token } = getState().app;
      const { orderId } = arg;
      let res = await fetch(
        API_URL + '/subscriptions/change-merchant-order-status-to-shipping',
        {
          body: JSON.stringify({ live: true, merchantOrderId: orderId }),
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (res.status === 200) {
        return await res.json();
      }
      return rejectWithValue({ error: true, errorCode: res.status });
    } catch (e) {
      return rejectWithValue({ error: true, errorCode: 900 });
    }
  },
);
const changeOrderShippingToNew = createAsyncThunk(
  'CHANGE_SHIPPING_NEW',
  async (arg, { getState, rejectWithValue }) => {
    try {
      const { token } = getState().app;
      const { orderId } = arg;
      let res = await fetch(
        API_URL + '/subscriptions/change-merchant-order-status-to-new',
        {
          body: JSON.stringify({ live: true, merchantOrderId: orderId }),
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (res.status === 200) {
        return await res.json();
      }
      return rejectWithValue({ error: true, errorCode: res.status });
    } catch (e) {
      return rejectWithValue({ error: true, errorCode: 900 });
    }
  },
);

const orderSlice = createSlice({
  name: 'orders',
  initialState: {
    isFetchingOrderPagin: false,
    isFetchingOrder: false,
    updatingOrder: false,
    errorOrder: false,
    errorOrderPagin: false,
    paginator: {},
    arrOrders: [],
    isFetchingOrdersStats: false,
    stats: {},
    changingOrderStatus: false,
    orderSelected: null,
    errorUpdating: false,
  },
  reducers: {
    selectOrder(state, action) {
      state.orderSelected = action.payload;
    },
  },
  extraReducers: {
    [requestOrderStats.pending]: (state) => {
      state.isFetchingOrdersStats = true;
      state.errorOrder = false;
    },
    [requestOrderStats.fulfilled]: (state, action) => {
      state.isFetchingOrdersStats = false;
      state.errorOrder = false;
      state.stats = action.payload;
    },
    [requestOrderStats.rejected]: (state, action) => {
      state.isFetchingOrdersStats = false;
      state.errorOrder = action.payload;
    },
    [requestOrdersPagin.pending]: (state) => {
      state.isFetchingOrderPagin = true;
      state.errorOrderPagin = false;
    },
    [requestOrdersPagin.fulfilled]: (state, action) => {
      state.isFetchingOrderPagin = false;
      state.errorOrderPagin = false;
      state.paginator = action.payload;
    },
    [requestOrdersPagin.rejected]: (state, action) => {
      state.isFetchingOrderPagin = false;
      state.errorOrderPagin = action.payload;
    },
    [requestOrders.pending]: (state) => {
      state.isFetchingOrder = true;
      state.errorOrder = false;
    },
    [requestOrders.fulfilled]: (state, action) => {
      state.isFetchingOrder = false;
      state.errorOrder = false;
      state.arrOrders = action.payload;
    },
    [requestOrders.rejected]: (state, action) => {
      state.isFetchingOrder = false;
      state.errorOrder = action.payload;
    },
    [changeOrderNewToShipping.pending]: (state) => {
      state.updatingOrder = true;
      state.errorUpdating = false;
    },
    [changeOrderNewToShipping.fulfilled]: (state, action) => {
      state.updatingOrder = false;
      state.errorUpdating = false;
      let orderUpdated = action.payload;
      let arr = [...state.arrOrders];
      let temp = arr.filter((order) => order.id !== orderUpdated.id);
      state.arrOrders = temp;
      state.stats.newOrders = state.stats.newOrders - 1;
    },
    [changeOrderNewToShipping.rejected]: (state, action) => {
      state.updatingOrder = false;
      state.errorUpdating = action.payload;
    },
    [changeOrderShippingToNew.pending]: (state) => {
      state.updatingOrder = true;
      state.errorUpdating = false;
    },
    [changeOrderShippingToNew.fulfilled]: (state, action) => {
      state.updatingOrder = false;
      state.errorUpdating = false;
      let orderUpdated = action.payload;
      let arr = [...state.arrOrders];
      let temp = arr.filter((order) => order.id !== orderUpdated.id);
      state.arrOrders = temp;
      state.stats.newOrders = state.stats.newOrders + 1;
    },
    [changeOrderShippingToNew.rejected]: (state, action) => {
      state.updatingOrder = false;
      state.errorUpdating = action.payload;
    },
  },
});
export const { selectOrder } = orderSlice.actions;
export {
  requestOrderStats,
  requestOrdersPagin,
  requestOrders,
  changeOrderNewToShipping,
  changeOrderShippingToNew,
};
export default orderSlice.reducer;
